export default __webpack_public_path__ + "static/media/ruecken-preview.2c5501d7.png";